import { useMemo, Fragment } from 'react';
import { getGradientDetails } from './utilities/getGradientDetails.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { uniqueId } from '../../../../utilities/uniqueId.js';
import { usePolarisVizContext } from '../../../../hooks/usePolarisVizContext.js';
import { LinearGradientWithStops } from '../../../LinearGradientWithStops/LinearGradientWithStops.js';

function DefaultArea({
  series,
  areaPath
}) {
  const gradientId = useMemo(() => uniqueId('default-area-gradient'), []);
  const maskId = useMemo(() => uniqueId('default-area-mask'), []);
  const {
    data,
    areaColor
  } = series;
  const {
    components: {
      Path,
      Defs,
      Mask
    },
    animated
  } = usePolarisVizContext();
  const AnimatedPath = animated(Path);
  const gradientStops = useMemo(() => {
    return getGradientDetails(data).map(gradientStop => ({ ...gradientStop,
      color: areaColor
    }));
  }, [areaColor, data]);

  if (areaPath == null || areaColor == null || gradientStops == null) {
    return null;
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Defs, {
      children: [/*#__PURE__*/jsx(Mask, {
        id: maskId,
        children: /*#__PURE__*/jsx(AnimatedPath, {
          d: areaPath,
          fill: `url(#${maskId}-gradient)`
        })
      }), /*#__PURE__*/jsx(LinearGradientWithStops, {
        id: `${maskId}-gradient`,
        x1: "0%",
        x2: "100%",
        y1: "0%",
        y2: "0%",
        gradient: [{
          offset: 0,
          color: 'black'
        }, {
          offset: 10,
          color: 'white'
        }, {
          offset: 90,
          color: 'white'
        }, {
          offset: 100,
          color: 'black'
        }]
      }), /*#__PURE__*/jsx(LinearGradientWithStops, {
        id: gradientId,
        x1: "0%",
        x2: "0%",
        y1: "0%",
        y2: "100%",
        gradient: gradientStops
      })]
    }), /*#__PURE__*/jsx(AnimatedPath, {
      d: areaPath,
      fill: `url(#${gradientId})`,
      mask: `url(#${maskId})`,
      strokeWidth: "0",
      stroke: areaColor,
      style: {
        pointerEvents: 'none'
      }
    })]
  });
}

export { DefaultArea };
